<div class="content">
  <div class="logo">
    <img src="assets/opted-icon.png" alt="Opted Out Email logo" />
  </div>
  <h2>{{ title }}</h2>
  <p>{{ subtext }}</p>

  <g99-button
    *ngIf="showButton"
    width="120px"
    variant="medium"
    color="secondary"
    [svgIcon]="svgIcon"
    (buttonClick)="onButtonClick()"
  >
    {{ buttonLabel }}
  </g99-button>
</div>
